module.exports = __webpack_public_path__ + "static/media/main-title.a57f85a9.svg";